<template>
  <NuxtLayout name="default">
    <div class="flex py-l h-screen">
      <div class="mx-auto text-center max-w-3xl">
        <h1 v-if="error.statusCode">{{ errorMessage }}</h1>

        <div class="flex justify-center gap-8 mt-8">
          <nuxt-link :to="$localeRootPath('/')" class="font-medium inline-flex items-center"
            >{{ $t('errorPages.goToHomepage') }}<InlineArrowIcon class="ml-2 h-2"
          /></nuxt-link>
          <nuxt-link :to="$localeRootPath('/shop')" class="font-medium inline-flex items-center"
            >{{ $t('errorPages.goToTheShop') }}<InlineArrowIcon class="ml-2 h-2"
          /></nuxt-link>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script>
import InlineArrowIcon from '@/components/icons/InlineArrowIcon';
import { useEntryPage } from '@/composables/useEntryPage';

export default defineNuxtComponent({
  components: { InlineArrowIcon },

  layout: 'default',

  scrollToTop: true,

  setup(props) {
    const { t } = useI18n();
    const { gtmPushPageMeta } = useEntryPage();

    // Handle redirects for content protection errors
    // Note: error.data may be a JSON string that needs to be parsed
    const errorData = typeof props.error?.data === 'string' ? JSON.parse(props.error.data) : props.error?.data;

    if (errorData?.redirectUrl) {
      return navigateTo(errorData.redirectUrl);
    }

    const pageTitle = computed(() => {
      switch (props.error.statusCode) {
        case 500:
          return '500-Error: Internal server error';
        case 410:
          return '410-Error: Gone forever';
        case 404:
          return '404-Error: Not found';
        default:
          return props.error.statusCode + '-Error';
      }
    });

    const errorMessage = computed(() => {
      switch (props.error.statusCode) {
        case 500:
          return t('errorPages.500');
        case 410:
          return t('errorPages.410');
        default:
          return t('errorPages.404');
      }
    });

    useHead({
      title: pageTitle,
    });

    return {
      pageTitle,
      errorMessage,
      gtmPushPageMeta,
    };
  },

  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    const eventData = {
      page_title: this.pageTitle,
      page_path:
        '/' +
        this.error.statusCode +
        '?page=' +
        document.location.pathname +
        document.location.search +
        '&from=' +
        document.referrer,
    };
    this.gtmPushPageMeta({ ...eventData });
  },
});
</script>
